<template>
  <validation-observer ref="observer">
    <div class="has-margin-top-20">
      <div class="columns is-multiline">
        <div class="column is-6 is-top-paddingless is-bottom-paddingless">
          <validation-provider
            v-slot="{ errors }"
            :name="$t('Full Name')"
            rules="required"
          >
            <div class="field">
              <label class="label is-size-6 has-text-grey">
                <vue-icon-base
                  height="16"
                  width="16"
                  :path="$options.icons[$kc('uni-phone')]"
                >
                </vue-icon-base>
                {{ $t('fullName') }}
                <span class="has-text-danger is-size-7">*</span>
              </label>
              <div class="control">
                <input
                  v-model="formValues.full_name"
                  :class="{
                    'is-danger': errors.length || get(fieldErrors, 'full_name')
                  }"
                  class="input"
                  type="text"
                  :placeholder="$t('fullName')"
                />
              </div>
              <p class="field-error help is-danger">
                {{ errors[0] || get(fieldErrors, 'full_name') }}
              </p>
            </div>
          </validation-provider>
        </div>
        <div class="column is-6 is-top-paddingless is-bottom-paddingless">
          <validation-provider
            v-slot="{ errors }"
            :name="$t('Phone Number')"
            rules="required"
          >
            <div class="field">
              <label class="label is-size-6 has-text-grey">
                <vue-icon-base
                  height="16"
                  width="16"
                  :path="$options.icons[$kc('uni-phone')]"
                >
                </vue-icon-base>
                {{ $t('Phone Number') }}
                <span class="has-text-danger is-size-7">*</span>
              </label>
              <div class="control">
                <input
                  v-model="formValues.phone_number"
                  :class="{
                    'is-danger':
                      errors.length || get(fieldErrors, 'phone_number')
                  }"
                  class="input"
                  type="text"
                  :placeholder="$t('Phone Number')"
                />
              </div>
              <p class="field-error help is-danger">
                {{ errors[0] || get(fieldErrors, 'phone_number') }}
              </p>
            </div>
          </validation-provider>
        </div>
        <div class="column is-12 is-top-paddingless is-bottom-paddingless">
          <validation-provider
            v-slot="{ errors }"
            :name="$t('email')"
            rules="required"
          >
            <div class="field">
              <label class="label is-size-6 has-text-grey">
                <vue-icon-base
                  height="16"
                  width="16"
                  :path="$options.icons[$kc('uni-envelope')]"
                >
                </vue-icon-base>
                {{ $t('email') }}
                <span class="has-text-danger is-size-7">*</span>
              </label>
              <div class="control">
                <input
                  v-model="formValues.email"
                  :class="{
                    'is-danger': errors.length || get(fieldErrors, 'email')
                  }"
                  class="input"
                  type="email"
                  :placeholder="$t('email')"
                />
              </div>
              <p class="field-error help is-danger">
                {{ errors[0] || get(fieldErrors, 'email') }}
              </p>
            </div>
          </validation-provider>
        </div>
        <div class="column is-12 is-top-paddingless is-bottom-paddingless">
          <validation-provider
            v-slot="{ errors }"
            :name="$t('Description')"
            rules="required"
          >
            <div class="field">
              <label class="label is-size-6 has-text-grey">
                <vue-icon-base
                  height="16"
                  width="16"
                  :path="$options.icons[$kc('uni-phone')]"
                >
                </vue-icon-base>
                {{ $t('Description') }}
                <span class="has-text-danger is-size-7">*</span>
              </label>
              <div class="control">
                <textarea
                  v-model="formValues.description"
                  rows="6"
                  :class="{
                    'is-danger':
                      errors.length || get(fieldErrors, 'description')
                  }"
                  class="textarea"
                  :placeholder="$t('Description')"
                ></textarea>
              </div>
              <p class="field-error help is-danger">
                {{ errors[0] || get(fieldErrors, 'description') }}
              </p>
            </div>
          </validation-provider>
        </div>
        <div class="column is-12 is-top-paddingless has-text-centered">
          <button
            class="button is-medium is-jobseeker has-text-white is-size-6"
            @click="addNewInfo()"
          >
            {{ $t('Send Message') }}
          </button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import {
  uniPhone,
  uniGlobe,
  uniLocationPoint,
  uniPhoneVolume,
  uniEnvelope
} from '@/helpers/icons'
import formMixin from '@/mixins/veeValidate'
import UserProfileMixin from '@/mixins/userProfile'
export default {
  mixins: [formMixin, UserProfileMixin],
  components: { VueIconBase },
  data() {
    return {
      formValues: {},
      endpoint: '/api/v1/common/contact-us/',
      createSuccessMessage: 'You will be contacted Soon'
    }
  },
  head() {
    return {
      title: 'Contact Us | Rojgari'
    }
  },
  icons: {
    uniPhone,
    uniGlobe,
    uniLocationPoint,
    uniPhoneVolume,
    uniEnvelope
  }
}
</script>
